import serverCall from "../../serverCall";

const createLiveImage = async (data) => {
    const response = await serverCall.post(
        `/images/admin/live-Wallpapers`, data
    );
    return response;
};

const createLiveMultImages = async (data) => {
    const response = await serverCall.post(`/images/admin/multi-liveWallpapers`,data);
    return response;
};

const liveWallpaperService = {
    createLiveImage,
    createLiveMultImages,
};

export default liveWallpaperService;
